<script lang="ts">
	import Card from '@smui/card';
	import Checkbox from '@smui/checkbox';
	import Select, { Option } from '@smui/select';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import FieldLoading from '../../../..//shared/components/common/Loading/FieldLoading.svelte';
	import Modal from '../../../..//shared/components/common/Modal/Modal.svelte';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import ConfirmModal from '../../../../shared/components/common/Modal/ConfirmModal.svelte';
	import { resetPageIfFiltersChanged } from '../../../../shared/functions';
	import AziendaEnte from '../../../../shared/models/AziendaEnte/AziendaEnte';
	import IndirizzoDipendente from '../../../../shared/models/Dipendente/IndirizzoDipendente';
	import FiltroGenerico from '../../../../shared/models/Filtri/FiltroGenerico';
	import Sede from '../../../../shared/models/Sede/Sede';
	import { hasRoleAreaManager, hasRoleSysAdmin, userSession } from '../../../../shared/stores';
	import TableLoading from './../../../..//shared/components/common/Loading/TableLoading.svelte';
	import Pagination from './../../../..//shared/components/common/Table/Pagination.svelte';
	import IndirizzoDipendenteImport from './IndirizzoDipendenteImport.svelte';

	let filters: FiltroGenerico = {
		aziendaEnteId: null,
		sedeId: null,
		provincia: '',
		citta: '',
		cap: '',
		indirizzo: '',
		pagina: 1,
		elementiPerPagina: 10,
	};

	$: [data, loading, error] = IndirizzoDipendente.getList(filters);

	let [dataEliminazione, loadingEliminazione, errorEliminazione] = [null, null, null];

	let [dataAziendeEnti, loadingAziendeEnti, errorAziendeEnti] =
		$hasRoleAreaManager || $hasRoleSysAdmin
			? AziendaEnte.getList({ areaId: $userSession?.areaId })
			: [null, null, null];
	$: [dataSedi, loadingSedi, errorSedi] = Sede.getList({ areaId: $userSession?.areaId, aziendaEnteId: $userSession?.aziendaEnteId || selectedAziendaEnte?.id });

	let selectedAziendaEnte: AziendaEnte = new AziendaEnte();
	let selectedSede: Sede = new Sede();

	let showIndirizzoDipendenteImport: boolean = false;
	let indirizzoDipendenteImportDialog = null;
	let openConfirmDeleteDialog: boolean = false;
	let idToDelete: number = 0;
	let isImporting: boolean = false;

	async function onDelete(id) {
		if (id > 0) {
			[dataEliminazione, loadingEliminazione, errorEliminazione] = await IndirizzoDipendente.delete(id);
			if (!$errorEliminazione) {
				[data, loading, error] = IndirizzoDipendente.getList(filters);
			}
		} else {
			[data, loading, error] = await IndirizzoDipendente.deleteRange(filters);
		}
	}

	function handleImport(event) {
		// Reset importing state
		isImporting = false;
		// Chiudi la modal quando l'importazione è completata
		showIndirizzoDipendenteImport = false;
		if (indirizzoDipendenteImportDialog) {
			indirizzoDipendenteImportDialog.close();
		}
		[data, loading, error] = event.detail;
	}

	let prevFilters = {};

	$: {
		const newPage = resetPageIfFiltersChanged(prevFilters, filters);
		if (newPage !== null) {
			filters.pagina = newPage;
		}
		prevFilters = { ...filters };
	}
</script>

<Modal bind:showModal="{showIndirizzoDipendenteImport}" bind:dialog="{indirizzoDipendenteImportDialog}" preventOutsideClick="{isImporting}">
	<IndirizzoDipendenteImport 
		on:updateData="{handleImport}"
		on:importStart="{() => isImporting = true}"
		on:importEnd="{() => isImporting = false}"
	/>
</Modal>

<ConfirmModal 
	content="{idToDelete ? `Sei sicuro di voler completare l'operazione?` : (filters.sedeId && filters.aziendaEnteId ? `Sei sicuro di voler eliminare gli indirizzi della sede ${selectedSede?.denominazione} ed azienda/ente ${selectedAziendaEnte?.nomeAziendaEnte}?` : (filters.sedeId ? `Sei sicuro di voler eliminare gli indirizzi della sede ${selectedSede?.denominazione}?` : (filters.aziendaEnteId ? `Sei sicuro di voler eliminare gli indirizzi dell'azienda/ente ${selectedAziendaEnte?.nomeAziendaEnte}?` : `Sei sicuro di voler eliminare tutti gli indirizzi?`)))}"
	bind:showModal="{openConfirmDeleteDialog}"
	onConfirm="{() => onDelete(idToDelete)}"
/>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.employee.list.titleImport')}" />
		{#if !$hasRoleAreaManager}
			<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
				<span
					role="button"
					tabindex="0"
					on:click="{() => (showIndirizzoDipendenteImport = true)}"
					on:keydown="{(event) => {
						if (event.key === 'Enter') showIndirizzoDipendenteImport = true;
					}}"
					class="btn-white h-14 w-14 rounded-4xl sm:h-16 sm:w-16 block mx-auto text-center cursor-pointer"
				>
					<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">file_upload</span>
				</span>
				<!--
				<span
					on:click="{() => IndirizzoDipendente.export(filters)}"
					on:keydown="{(event) => {
						if (event.key === 'Enter') IndirizzoDipendente.export(filters);
					}}"
					class="btn-white h-14 w-14 rounded-4xl sm:h-16 sm:w-16 block mx-auto text-center cursor-pointer"
				>
					<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">file_download</span>
				</span>
				-->
				<button
					title="Cancella indirizzario"
					on:click="{() => {
						idToDelete = null;
						openConfirmDeleteDialog = true;
					}}"
					class="btn-white h-14 w-14 sm:h-16 sm:w-16"
				>
					<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">delete</span>
				</button>
			</div>
		{/if}
	</div>
	<div class="md:grid-cols-2 lg:grid-cols-3 grid grid-cols-1 gap-8 p-4">
		{#if $hasRoleSysAdmin}
			{#if $loadingAziendeEnti}
				<FieldLoading />
			{:else}
				<Select
					key="{(aziendaEnte) => `${(aziendaEnte && aziendaEnte.id) || ''}`}"
					label="{$_('page.survey.list.company/entity')}"
					bind:value="{selectedAziendaEnte}"
				>
					{#if $dataAziendeEnti && $dataAziendeEnti.response}
						<Option value="{null}" on:click="{() => (filters.aziendaEnteId = null)}">&#x200B;</Option>
						{#each $dataAziendeEnti.response as aziendaEnte (aziendaEnte.id)}
							{#if aziendaEnte?.nomeAziendaEnte}
								<Option value="{aziendaEnte}" on:click="{() => (filters.aziendaEnteId = aziendaEnte.id)}"
									>{aziendaEnte.nomeAziendaEnte}</Option
								>
							{/if}
						{/each}
					{/if}
				</Select>
			{/if}
		{/if}
		{#if $loadingSedi}
			<FieldLoading />
		{:else}
			<Select label="{$_('page.pscl.detail.location')}" key="{(sede) => `${(sede && sede.id) || ''}`}" bind:value="{selectedSede}">
				{#if $dataSedi.response}
					<Option value="{null}" on:click="{() => (filters.sedeId = null)}">&#x200B;</Option>
					{#each $dataSedi.response as sede (sede.id)}
						{#if sede.denominazione}
							<Option value="{sede}" on:click="{() => (filters.sedeId = sede.id)}">{sede.denominazione}</Option>
						{/if}
					{/each}
				{/if}
			</Select>
		{/if}
		<Input label="Provincia" bind:value="{filters.provincia}" />
		<Input label="Città" bind:value="{filters.citta}" />
		<Input label="CAP" bind:value="{filters.cap}" />
		<Input label="Indirizzo" bind:value="{filters.indirizzo}" />
	</div>
	<div class="flex flex-col">
		<div class="sm:-mx-6 lg:-mx-8 -my-2 overflow-x-auto">
			<div class="sm:px-6 lg:px-8 inline-block min-w-full py-2 align-middle">
				<div class="overflow-hidden">
					<table class="min-w-full p-0 m-0 text-sm leading-10 border-t-4 border-collapse border-black table-auto">
						<thead>
							<tr class="p-1">
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.province')}</th
								>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.city')}</th
								>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.postal_code')}</th
								>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.address')}</th
								>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.location')}</th
								>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.status')}</th
								>
								<th scope="col" class="relative border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('global.actions')}</th
								>
							</tr>
						</thead>
						<tbody>
							{#if $loading}
								<tr>
									<td colspan="7">
										<TableLoading />
									</td>
								</tr>
							{:else if $data?.response}
								{#each $data.response as row}
									<tr class="odd:bg-white even:bg-gray-50 p-1">
										<td class="border-b p-2.5 text-center leading-5">{row.provincia ?? ''}</td>
										<td class="border-b p-2.5 text-center leading-5">{row.citta ?? ''}</td>
										<td class="border-b p-2.5 text-center leading-5">{row.cap ?? ''}</td>
										<td class="border-b p-2.5 text-center leading-5"
											>{row.indirizzo ?? ''}
											{#if row.provincia && row.citta && row.cap && row.indirizzoOK}
												<span
													title="{$_('page.employee.list.valid_address')}"
													class="material-icons-outlined"
													style="color: green; font-size: 20px;">fmd_good</span
												>
											{:else}
												<span
													title="{$_('page.employee.list.not_valid_address')}"
													class="material-icons-outlined"
													style="color: red; font-size: 20px;">wrong_location</span
												>{/if}</td
										>
										<td class="border-b p-2.5 text-center leading-5">{row.sede?.denominazione ?? ''}</td>
										<td class="border-b p-2.5 text-center leading-5"
											>{#if row.indirizzoCancel} <Checkbox disabled /> {:else} <Checkbox disabled checked /> {/if}</td
										>
										<td class="whitespace-nowrap border-b p-2.5 text-center leading-5">
											<div class="item-center flex justify-center">
												<div>
													<a href="/#/indirizzodipendente/{row.id}">
														<button class="h-7.5 w-7.5">
															<span class="material-icons-outlined text-base leading-[1.8rem]">launch</span>
														</button>
													</a>
												</div>
												<div class="ml-4 h-7.5 w-7.5">
													<button
														on:click="{() => {
															idToDelete = row.id;
															openConfirmDeleteDialog = true;
														}}"
														class="h-7.5 w-7.5"
													>
														<span class="material-icons-outlined text-base leading-[1.8rem]">delete</span>
													</button>
												</div>
											</div>
										</td>
									</tr>
								{/each}
							{/if}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="right-0">
		{#if $data?.response}
			<Pagination bind:current="{filters.pagina}" bind:num_pages="{$data.totalPages}" bind:per_page="{filters.elementiPerPagina}" />
		{/if}
	</div>
</Card>